import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta3({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['a) Fomentar un ambiente de diálogo abierto.', 'c) Escuchar activamente a los integrantes del equipo.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta3', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			console.log('no');

			sumarPuntos(0);
			setRespuesta('pregunta3', seleccionadas, 0);
		}
		cambiarPregunta(4);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>3.</div> ¿Qué características son esenciales en un liderazgo conversacional? Selecciona todas las que apliquen:
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(!btn1);
								grabarSeleccionada('a) Fomentar un ambiente de diálogo abierto.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Fomentar un ambiente de diálogo abierto.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(!btn2);
								grabarSeleccionada('b) Controlar las decisiones de los demás.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Controlar las decisiones de los demás.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(!btn3);
								grabarSeleccionada('c) Escuchar activamente a los integrantes del equipo.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'>Escuchar activamente a los integrantes del equipo.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(!btn4);
								grabarSeleccionada('d) Evitar discusiones para mantener la armonía.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'>Evitar discusiones para mantener la armonía.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
